import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

const PasswordInput = ({
  placeholder = "Enter password",
  name,
  value,
  onChange,
}) => {
  const [visible, setVisible] = useState(false);

  const toggleVisibility = () => setVisible((prev) => !prev);

  return (
    <div className="relative w-full">
      <input
        name={name}
        value={value}
        onChange={onChange}
        type={visible ? "text" : "password"}
        placeholder={placeholder}
        className="h-[50px] w-full text-[14px] rounded-[5px] px-[10px] pr-[40px] border border-[#D9D9D9] focus:outline-none focus:ring-0 focus:ring-offset-0 focus:border-[#D9D9D9]"
      />
      <button
        type="button"
        onClick={toggleVisibility}
        className="absolute top-1/2 right-3 transform -translate-y-1/2 text-gray-500"
      >
        {visible ? <EyeOff size={20} /> : <Eye size={20} />}
      </button>
    </div>
  );
};

export default PasswordInput;
